@use '@/styles/tokens' as *;

/* Figma 787:678824. The card itself — background, radius, padding, shadow — belongs to
 * <MapAnchoredPanel>, which is the shell both panels share; everything here is the body inside it. */

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Figma 787:678787 — Main Font-Geist/16/R at Text/Primary. */
.title {
  margin: 0;
  font-size: $font-size-16;
  line-height: 1;
  color: var(--text-primary);
}

/* Figma 787:678788 — the two 20px carets, with the close control (no frame; grilling Q11) after them. */
.controls {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.step {
  @include reset-button;
  @include focus-ring;

  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  cursor: pointer;
}

/* Figma 787:678791 — Main Font-Geist/14/R at Text/Tertiary, 4px below the title. */
.subtitle {
  margin: var(--space-1) 0 0;
  font-size: $font-size-14;
  line-height: 1;
  color: var(--text-tertiary);
}

/* Figma 787:678792 — 12px below the title block, 10px between chips. 10px sits dead centre between
 * --space-2 (8) and --space-3 (12), so it is written raw with this note — the same substitution
 * map-control-stack.module.scss makes for its 6px button gap. */
.chips {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: var(--space-3) 0 0;
  padding: 0;
  list-style: none;
}

/* Figma 787:678793 / 787:678796 — a 28px bordered pill. `padding: 6px` is off the --space-* scale
 * (between 4 and 8) and written raw for the reason .chips records.
 *
 * The icon-to-text gap is 4px on the device chip and 8px on the crop chip in Figma — the design is
 * internally inconsistent, so the tighter value is taken for both and the row reads as one family. */
.chip {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: 6px;
  border: 1px solid var(--border-subtle);
  border-radius: $radius-md;
  font-size: $font-size-12;
  line-height: 1;
  color: var(--text-primary);
  white-space: nowrap;
}

/* Figma 787:678799 — ticket 10's Delete / Edit row, 24px below the content block. Empty until then. */
.actions {
  display: flex;
  gap: var(--space-4);
  margin-top: var(--space-6);
}
